import { render } from "./NewIssueButton.vue?vue&type=template&id=59374bae&scoped=true"
import script from "./NewIssueButton.vue?vue&type=script&lang=js"
export * from "./NewIssueButton.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-59374bae"

export default script